"use strict";

exports.__esModule = true;
exports.shadowParser = exports.shadow = void 0;

var _core = require("../core");

var _utils = require("../utils");

var config = {
  boxShadow: _utils.t.shadows("boxShadow"),
  textShadow: _utils.t.shadows("textShadow")
};
Object.assign(config, {
  shadow: config.boxShadow
});
/**
 * Types for box and text shadow properties
 */

var shadow = (0, _core.system)(config);
exports.shadow = shadow;
var shadowParser = (0, _core.createParser)(config);
exports.shadowParser = shadowParser;
//# sourceMappingURL=shadow.js.map